
import { motion } from 'motion/react';
import { useInView } from 'react-intersection-observer';
import SiteFooter from '../../components/SiteFooter';

const ROOT_FONT_STYLE = {
  fontFamily: '"Montserrat", -apple-system, BlinkMacSystemFont, sans-serif',
};

const LOGO_FONT_STYLE = {
  fontFamily: '"Avenir Next", -apple-system, BlinkMacSystemFont, sans-serif',
  fontWeight: 900,
};

const HERO_RADIAL_BACKGROUND_STYLE = {
  backgroundImage: `radial-gradient(circle at 25% 25%, rgba(199, 3, 3, 0.1) 0%, transparent 50%),
                             radial-gradient(circle at 75% 75%, rgba(199, 3, 3, 0.15) 0%, transparent 50%)`,
};

const HERO_GRID_BACKGROUND_STYLE = {
  backgroundImage: `linear-gradient(rgba(199, 3, 3, 0.3) 1px, transparent 1px),
                             linear-gradient(90deg, rgba(199, 3, 3, 0.3) 1px, transparent 1px)`,
  backgroundSize: '50px 50px',
};

export default function Home() {
  const { ref: heroRef, inView: heroInView } = useInView({
    threshold: 0.1,
    triggerOnce: true
  });

  return (
    <div className="min-h-screen bg-gray-900 text-white" style={ROOT_FONT_STYLE}>
      {/* Hero Section */}
      <section 
        ref={heroRef}
        className="relative min-h-screen flex items-center justify-center overflow-hidden"
      >
        {/* Animated Background */}
        <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-red-900/20 to-red-800/20">
          <div className="absolute inset-0" style={HERO_RADIAL_BACKGROUND_STYLE}></div>
        </div>
        
        {/* Grid Pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="h-full w-full" style={HERO_GRID_BACKGROUND_STYLE}></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={heroInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="mb-8"
          >
            <h1 className="text-6xl md:text-8xl font-black mb-6 bg-gradient-to-r from-red-400 via-red-500 to-red-600 bg-clip-text text-transparent" style={LOGO_FONT_STYLE}>
              Cupid
            </h1>
            <h2 className="text-3xl md:text-5xl font-bold mb-6 text-gray-100">
              A New Dating Experience
            </h2>
            <p className="text-xl md:text-2xl mb-8 max-w-4xl mx-auto leading-relaxed text-gray-300">
              Group-based matching for natural and comfortable dating<br />
              Start meaningful connections with real-time matching within 5km
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={heroInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="flex flex-col sm:flex-row gap-4 justify-center items-center"
          >
            <button className="bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer flex items-center gap-3">
              <i className="fab fa-apple text-2xl"></i>
              Download for iOS
            </button>
            <button className="bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer flex items-center gap-3">
              <i className="fab fa-google-play text-2xl"></i>
              Download for Android
            </button>
          </motion.div>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
}